import React from 'react';
import CTA from './CTA';
import Content from './Content';
import Features from './Features';
import Hero from './Hero';
import MarketData from './MarketData';
import Trading from './Trading';

const LandingPageComponent = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Hero />
      <MarketData/>
      <Content/>
      <Features />
      <Trading/>
      <CTA />
    </div>
  );
};

export default LandingPageComponent; 